document.addEventListener('click', function(event) {
    const browseSim = event.target.closest('.browse-sim');

    if (browseSim) {
        const isButton = event.target.classList.contains('button');
        const isAdded = event.target.closest('.browse-sim.added');

        if (!(isButton && isAdded)) {
            const dropzoneBtn = document.querySelector('.gfb__dropzone--placeholder--button');
            if (dropzoneBtn) dropzoneBtn.click();
        }
    }
});

function waitForElm(selector) {
    return new Promise(resolve => {
        const existing = document.querySelector(selector);
        if (existing) return resolve(existing);

        const observer = new MutationObserver(() => {
            const found = document.querySelector(selector);
            if (found) {
                observer.disconnect();
                resolve(found);
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    });
}

waitForElm('label.material_filled-label').then(label => {
    const browseSim = document.querySelector('.browse-sim');
    const fileNameDisplay = document.querySelector('.file-name');

    if (!label || !browseSim) return;

    const observer = new MutationObserver(() => {
        const isFilled = label.classList.contains('gfb__label__filled');

        if (isFilled) {
            browseSim.classList.add('added');

            waitForElm('.gfb__dropzone--preview--item-filename').then(filenameEl => {
                if (filenameEl && fileNameDisplay) {
                    fileNameDisplay.innerText = filenameEl.innerText;
                }
            });

        } else {
            browseSim.classList.remove('added');

            if (fileNameDisplay) {
                fileNameDisplay.innerText = 'YourResume.pdf';
            }
        }
    });

    observer.observe(label, { attributes: true, attributeFilter: ['class'] });
});

waitForElm('.browse-sim.added .button').then(button => {
    button.addEventListener('click', () => {
        const submitBtn = document.querySelector('.gfb__footer.wizard__footer button.submit');
        const browseSim = document.querySelector('.browse-sim');

        if (submitBtn) submitBtn.click();

        if (browseSim) {
            browseSim.innerHTML = `Thanks for contacting us. We&#39;ll get back to you as soon as possible.`;
            browseSim.style.justifyContent = 'center';
        }
    });
});